module.exports = __webpack_public_path__ + "img/11.32aa80a6.svg";